import { SafeResourceUrl } from '@angular/platform-browser';

export class IdNameImage {
  public static all = new IdNameImage(null, 'All', null);

  constructor(public id: number, public name: string, public imgSrc: SafeResourceUrl) {}
}
